import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ResponseObject } from 'src/app/models/response-object.model';
import { VendorResponse } from 'src/app/models/vendor.model';
import { VendorService } from 'src/app/services/vendor.service';

@Component({
  selector: 'app-modal-client-cf',
  templateUrl: './modal-client-cf.component.html',
  styleUrls: ['./modal-client-cf.component.scss']
})
export class ModalClientCfComponent {

  @Output() close = new EventEmitter<boolean>();

  loading: boolean = false;

  name: string = '';
  cellphone: string = '';

  constructor(
    private vendorService: VendorService,
    private toastService: ToastrService
  ) {}

  save(): void {

    const name = this.name?.trim();
    const cellphone = this.cellphone?.trim();

    if (!name) {
      this.toastService.info('Debes ingresar el nombre del cliente');
      return;
    }

    if (!cellphone) {
      this.toastService.info('Debes ingresar el número de celular');
      return;
    }

    const newClient = this.buildClientRequest(name, cellphone);

    this.loading = true;

    this.vendorService.postVendor(newClient).subscribe({
      next: (response: ResponseObject) => {

        this.loading = false;

        this.toastService.success(
          'Cliente creado correctamente'
        );

        this.clean();

        
        this.close.emit(true);
      },

      error: (error: HttpErrorResponse) => {

        this.loading = false;

        this.toastService.error(
          error.error?.message ||
          'No se pudo crear el cliente'
        );
      }
    });
  }

  private buildClientRequest(
    name: string,
    cellphone: string
  ): VendorResponse {

    const client = new VendorResponse();

    client.name = name;
    client.contactCellphone = cellphone;


    // Siempre consumidor final
    client.nit = 'CF';

    // Siempre cliente
    client.client = true;

    // Nunca proveedor
    client.provider = false;
    client.provIn = false;
    client.extranjero = false;

    // Datos vacios
    client.cui = null;
    client.code = null;
    client.priceList = null;
    client.address = null;
    client.contactName = null;
    client.contactMail = null;
    client.contactPhone = null;
    client.contactCellphone = cellphone;
    client.place = null;
    client.clientCredit = null;
    client.percentage = 0;

    // No tiene NITs adicionales
    client.billingRequest = [];

    // No tiene dias de credito
    client.providerCreditDays = 0;
    client['categories'] = [];

    return client;
  }

  cancel(): void {
    if (this.loading) {
      return;
    }

    this.clean();
    this.close.emit(false);
  }

  private clean(): void {
    this.name = '';
    this.cellphone = '';
  }
}